import { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const insights = [
  {
    id: 1,
    category: 'Danışmanlık',
    title: 'TGB Danışmanlık Firması Seçerken Dikkat Edilmesi Gerekenler',
    excerpt: 'Tesis Güvenlik Belgesi sürecinde doğru danışmanlık firmasıyla çalışmak kritik önem taşır. Sektör deneyimi, MSB süreçlerine hakimiyet ve daha fazlası.',
    readTime: '10 dk',
    image: 'https://public.readdy.ai/ai/img_res/61283b54d347fd0ea46efe05cb5860ec.jpg',
    link: '/blog/tgb-danismanlik-firmasi-secimi'
  },
  {
    id: 2,
    category: 'Mevzuat',
    title: 'Tesis Güvenlik Belgesi Nedir ve Neden Gereklidir?',
    excerpt: 'Tesis Güvenlik Belgesi (TGB), savunma sanayii projelerinde çalışan kuruluşların gizli bilgileri koruma yeterliliğini belgeleyen resmi bir dokümandır.',
    readTime: '8 dk',
    image: 'https://readdy.ai/api/search-image?query=modern%20secure%20facility%20building%20with%20security%20systems%20professional%20business%20environment%20clean%20minimalist%20background%20high%20tech%20security%20infrastructure%20daylight%20architectural%20photography%20style&width=800&height=500&seq=blog1&orientation=landscape',
    link: '/blog/tesis-guvenlik-belgesi-nedir'
  },
  {
    id: 3,
    category: 'Rehber',
    title: 'MSB Tesis Güvenlik Belgesi Başvuru Süreci Adım Adım',
    excerpt: 'MSB Tesis Güvenlik Belgesi başvuru süreci detaylı bir hazırlık gerektirir. Bu rehberde başvurudan belge alımına kadar tüm adımları bulabilirsiniz.',
    readTime: '12 dk',
    image: 'https://readdy.ai/api/search-image?query=business%20professionals%20reviewing%20documents%20and%20paperwork%20in%20modern%20office%20meeting%20room%20consultation%20process%20clean%20professional%20environment%20natural%20lighting%20corporate%20photography%20style&width=800&height=500&seq=blog2&orientation=landscape',
    link: '/blog/msb-basvuru-sureci'
  },
  {
    id: 4,
    category: 'Süreç',
    title: 'NATO Tesis Güvenlik Belgesi ile Milli TGB Arasındaki Farklar',
    excerpt: 'NATO TGB ve Milli TGB arasındaki temel farkları, başvuru şartlarını ve hangi durumlarda hangi belgenin gerekli olduğunu detaylı olarak inceliyoruz.',
    readTime: '10 dk',
    image: 'https://readdy.ai/api/search-image?query=international%20business%20cooperation%20nato%20flags%20and%20documents%20on%20conference%20table%20professional%20diplomatic%20setting%20clean%20modern%20office%20environment%20formal%20business%20photography%20style&width=800&height=500&seq=blog3&orientation=landscape',
    link: '/blog/nato-tgb-milli-tgb-farklari'
  },
  {
    id: 5,
    category: 'Güvenlik',
    title: 'Tesis Güvenlik Belgesi için Fiziki Güvenlik Gereksinimleri',
    excerpt: 'TGB alabilmek için tesislerinizin karşılaması gereken fiziki güvenlik standartları: CCTV sistemleri, erişim kontrol, alarm sistemleri ve daha fazlası.',
    readTime: '15 dk',
    image: 'https://readdy.ai/api/search-image?query=modern%20security%20camera%20system%20and%20access%20control%20technology%20in%20corporate%20building%20high%20tech%20surveillance%20equipment%20clean%20professional%20installation%20security%20infrastructure%20photography%20style&width=800&height=500&seq=blog4&orientation=landscape',
    link: '/blog/fiziki-guvenlik-gereksinimleri'
  },
  {
    id: 6,
    category: 'Personel',
    title: 'Personel Güvenlik Soruşturması Süreci ve Hazırlık',
    excerpt: 'Gizlilik dereceli projelerde çalışacak personel için zorunlu olan güvenlik soruşturması süreci, gerekli belgeler ve hazırlık aşamaları.',
    readTime: '11 dk',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20person%20with%20security%20badge%20and%20documents%20in%20modern%20corporate%20office%20employee%20verification%20process%20clean%20professional%20environment%20business%20photography%20style&width=800&height=500&seq=blog5&orientation=landscape',
    link: '/blog/personel-guvenlik-sorusturmasi'
  }
];

export default function Insights() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkScroll();
    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', checkScroll);
      return () => scrollElement.removeEventListener('scroll', checkScroll);
    }
  }, []);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      const newScrollLeft = direction === 'left' 
        ? scrollRef.current.scrollLeft - scrollAmount
        : scrollRef.current.scrollLeft + scrollAmount;
      
      scrollRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="insights" className="py-24 px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 flex items-center justify-between">
          <div>
            <h2 className="font-serif text-5xl font-bold text-gray-900">
              Güncel <span className="text-orange-500">Bilgiler</span>
            </h2>
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 mt-4 text-sm font-medium text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
            >
              Tüm Yazıları Gör
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          
          <div className="flex gap-3">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className={`w-12 h-12 flex items-center justify-center rounded-full border-2 transition-all cursor-pointer ${
                canScrollLeft 
                  ? 'border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white' 
                  : 'border-gray-300 text-gray-300 cursor-not-allowed'
              }`}
              aria-label="Scroll left"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className={`w-12 h-12 flex items-center justify-center rounded-full border-2 transition-all cursor-pointer ${
                canScrollRight 
                  ? 'border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white' 
                  : 'border-gray-300 text-gray-300 cursor-not-allowed'
              }`}
              aria-label="Scroll right"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>

        <div 
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide" 
          style={{ scrollbarWidth: 'none' }}
        >
          {insights.map((insight, index) => (
            <Link
              to={insight.link}
              key={index}
              className="flex-shrink-0 w-[280px] bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all cursor-pointer group"
            >
              <div className="w-full h-[280px] overflow-hidden">
                <img
                  src={insight.image}
                  alt={insight.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-3">
                  {insight.category}
                </p>
                <h3 className="text-lg font-bold text-gray-900 mb-4 leading-snug line-clamp-2">
                  {insight.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">{insight.readTime}</span>
                  <i className="ri-arrow-right-line text-orange-500 text-xl group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
